import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=b9edec58&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9edec58",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b9edec58')) {
      api.createRecord('b9edec58', component.options)
    } else {
      api.reload('b9edec58', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=b9edec58&scoped=true&", function () {
      api.rerender('b9edec58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4xK9BRlRhAyvI/JS/comp/SearchFilterTokens.vue"
export default component.exports